import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingUspComponentData extends ConvertedComponentData {
  trainingId?: string;
}

export const TRAINING_USP_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingUspComponentData>[]>('TrainingUspConverter')
